import styled from '@emotion/styled'

import {
  INPUTGROUP_VARIANT_DANGER,
  INPUTGROUP_VARIANT_DEFAULT
} from './InputGroup.constants'

import { input } from '../../design/tokens'

const handleVariant = ({ $variant }) => {
  switch ($variant) {
    case INPUTGROUP_VARIANT_DEFAULT:
      return `
      & > * {
        border-color: ${input.color.border.default};
      }
      

      &:focus-within > *, 
      &:hover > * {
        border-color: ${input.color.border.hover};
      }

      /* hack for input-text */

      & > .e-input-text > .e-input-text__input {
        border-color: ${input.color.border.default};
      }

      &:focus-within > .e-input-text > .e-input-text__input, 
      &:hover > .e-input-text > .e-input-text__input {
        border-color: ${input.color.border.hover};
      }
      
      `

    case INPUTGROUP_VARIANT_DANGER:
      return `

      & > * {
        border-color: ${input.color.border.danger};
      }
      

      &:focus-within > *, 
      &:hover > * {
        border-color: ${input.color.border.danger};
      }

      /* hack for input-text */

      & > .e-input-text > .e-input-text__input {
        border-color: ${input.color.border.danger};
      }

      &:focus-within > .e-input-text > .e-input-text__input, 
      &:hover > .e-input-text > .e-input-text__input {
        border-color: ${input.color.border.danger};
      }
      
      `

    default:
      return ''
  }
}

const handleDisabled = ({ $disabled }) => {
  if ($disabled) {
    return `
    /*
    color: ${input.color.text.disabled};
    background-color: ${input.color.background.disabled};
    */

    border-color: ${input.color.border.disabled};

    &:focus-within, &:hover {
      border-color: ${input.color.border.hover};
    }
    
    `
  }

  return ''
}

export const StyledInputGroup = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;

  color: ${input.color.text.default};
  background-color: ${input.color.background.default};
  background-clip: padding-box;

  height: ${input.height};
  min-height: ${input.minHeight};

  transition: all 0.3s ease;

  & .e-input-text__input,
  & .e-input-text input[type='text'],
  & .e-toggle-btn {
    border-radius: 0;
    border-width: 1px;
    border-style: solid;
    border-left-width: 0;
    border-right-width: 0;
  }

  & .e-input-text:first-child .e-input-text__input,
  & .e-toggle-btn:first-child {
    border-top-left-radius: ${input.borderRadius};
    border-bottom-left-radius: ${input.borderRadius};
    border-left-width: 1px;
  }

  & .e-input-text:last-child .e-input-text__input,
  & .e-toggle-btn:last-child {
    border-top-right-radius: ${input.borderRadius};
    border-bottom-right-radius: ${input.borderRadius};
    border-right-width: 1px;
  }

  & .e-input-text {
    width: 100%;
  }

  /* e-button */

  & .e-button--primary {
    border-radius: 0;
  }

  & .e-button--primary:first-child {
    border-top-left-radius: ${input.borderRadius};
    border-bottom-left-radius: ${input.borderRadius};
  }

  & .e-button--primary:last-child {
    border-top-right-radius: ${input.borderRadius};
    border-bottom-right-radius: ${input.borderRadius};
  }

  ${handleVariant}
  ${handleDisabled}
`

export const StyledInputGroupSeparator = styled.div`
  border: 0;
  margin: 0;
  padding: 0;
  border-left: 1px solid ${input.color.border.default} !important;
  height: 100%;
`

/*
@import '../../sass/00_tokens/colors.variables';

$e-input-text-color: $tundora;
$e-input-text-color--disabled: #929292;
$e-input-placeholder-color: #B9B9B9;
$e-input-text-background: $pure-white;
$e-input-text-background--disabled: #e9e9e9;

$e-input-text-border-color: #d5dadf;
$e-input-text-border-color--hover: $bombay;
$e-input-text-border-color--focus: $bombay;
$e-input-text-border-color--danger: $sunset-orange;
$e-input-text-border-color--disabled: $geyser;


$e-input-text-font-size: 15px;
$e-input-text-height: 36px;
$e-input-text-padding-h: 8px;


*/
